import React from "react";
import { createPortal } from "react-dom";
import { FaTimes } from "react-icons/fa";

const formatDisplayDate = (dateStr) => {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
};

const formatDisplayDateTime = (dateStr) => {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

const AppAccessDetailsModal = ({ patient, appAccess, onClose }) => {
  if (!patient) return null;

  const detailRow = (label, value) => (
    <div style={{ marginBottom: "14px" }}>
      <div style={{ fontSize: "11px", color: "#8E8E93", marginBottom: "2px" }}>{label}</div>
      <div style={{ fontSize: "14px", fontWeight: 600, color: "#064260" }}>{value || "—"}</div>
    </div>
  );

  const isLinked = appAccess?.status === "Linked";

  return createPortal(
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.45)",
        zIndex: 1070,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: "#FFFFFF",
          borderRadius: "12px",
          width: "440px",
          maxWidth: "100%",
          maxHeight: "90vh",
          overflowY: "auto",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.18)",
          fontFamily: "Poppins, sans-serif",
        }}
      >
        <div
          style={{
            backgroundColor: "#0A3652",
            padding: "18px 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "sticky",
            top: 0,
          }}
        >
          <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#FFFFFF" }}>
            App Access Details
          </h3>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#FFFFFF",
              padding: "2px",
              display: "flex",
            }}
          >
            <FaTimes size={16} />
          </button>
        </div>

        <div style={{ padding: "24px" }}>
          {detailRow("App Link Status", appAccess?.status)}
          {detailRow("Linked Date", formatDisplayDate(appAccess?.connectedDate))}
          {isLinked &&
            detailRow(
              "Linked App User",
              [
                appAccess?.linkedAppUserName,
                appAccess?.linkedAppUserDisplayId,
              ]
                .filter(Boolean)
                .join(" • ") || "—",
            )}
          {isLinked && detailRow("Notification Status", appAccess?.notificationStatus)}
          {isLinked &&
            detailRow(
              "Notification Sent Date",
              formatDisplayDateTime(appAccess?.notificationSentAt),
            )}
          {isLinked &&
            detailRow(
              "Last App Activity",
              formatDisplayDateTime(appAccess?.lastAppActivity),
            )}
          {!isLinked &&
            detailRow(
              "Invite Sent",
              formatDisplayDate(appAccess?.lastInviteSentAt || appAccess?.inviteSentAt),
            )}
          {detailRow("Access Code", appAccess?.accessCode)}
          {detailRow("Clinic", appAccess?.clinic || patient.clinic)}
          {detailRow("Care Manager", appAccess?.careManager || patient.cm)}
          {detailRow("Patient Email", patient.email)}
          {appAccess?.linkSource && detailRow("Link Source", appAccess.linkSource)}

          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "8px" }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                padding: "10px 24px",
                borderRadius: "8px",
                border: "1px solid #EAECEF",
                backgroundColor: "#FFFFFF",
                color: "#064260",
                fontWeight: 600,
                fontSize: "14px",
                cursor: "pointer",
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default AppAccessDetailsModal;
